import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Application from '../Application';
import EventEmitter from './EventEmitter';
export default class Resources extends EventEmitter {
    constructor(sources) {
        super();
        this.sources = sources;
        this.items = { texture: {}, cubeTexture: {}, gltfModel: {}, audio: {} };
        this.toLoad = this.sources.length;
        this.loaded = 0;
        this.application = new Application();
        this.loading = this.application.loading;
        this.setLoaders();
        this.startLoading();
    }
    setLoaders() {
        this.loaders = {
            gltfLoader: new GLTFLoader(),
            textureLoader: new THREE.TextureLoader(),
            cubeTextureLoader: new THREE.CubeTextureLoader(),
            audioLoader: new THREE.AudioLoader(),
        };
    }
    startLoading() {
        for (const source of this.sources) {
            console.log('PROVO A CARICARE:', source.name, source.type, source.path);
            if (source.type === 'gltfModel') {
                this.loaders.gltfLoader.load(source.path, (file) => {
                    console.log('OK MODELLO:', source.name, source.path);
                    this.sourceLoaded(source, file);
                }, undefined, (error) => {
                    console.error('ERRORE MODELLO:', source.name, source.path, error);
                });
            }
            else if (source.type === 'texture') {
                this.loaders.textureLoader.load(source.path, (file) => {
                    console.log('OK TEXTURE:', source.name, source.path);
                    file.encoding = THREE.sRGBEncoding;
                    this.sourceLoaded(source, file);
                }, undefined, (error) => {
                    console.error('ERRORE TEXTURE:', source.name, source.path, error);
                });
            }
            else if (source.type === 'cubeTexture') {
                this.loaders.cubeTextureLoader.load(source.path, (file) => {
                    console.log('OK CUBETEXTURE:', source.name, source.path);
                    this.sourceLoaded(source, file);
                }, undefined, (error) => {
                    console.error('ERRORE CUBETEXTURE:', source.name, source.path, error);
                });
            }
            else if (source.type === 'audio') {
                this.loaders.audioLoader.load(source.path, (buffer) => {
                    console.log('OK AUDIO:', source.name, source.path);
                    this.sourceLoaded(source, buffer);
                }, undefined, (error) => {
                    console.error('ERRORE AUDIO:', source.name, source.path, error);
                });
            }
        }
    }
    sourceLoaded(source, file) {
        this.items[source.type][source.name] = file;
        this.loaded++;
        this.loading.trigger('loadedSource', [
            source.name,
            this.loaded,
            this.toLoad,
        ]);
        if (this.loaded === this.toLoad) {
            this.trigger('ready');
        }
    }
}
